import { render, staticRenderFns } from "./musteri_borclu.vue?vue&type=template&id=6a0dd538&"
import script from "./musteri_borclu.vue?vue&type=script&lang=js&"
export * from "./musteri_borclu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports